<div class="new-login-ui fresh-ui" @slideInFromBottom>
    <div class="modal-header">
        <div class="font-600 fs-pv-title general_sans">
            How It Works
        </div>
        <span class="material-icons pr-2 d-flex cursor-pointer cursor-pointer" (click)="closeVideoPreview()">
            cancel
        </span>
    </div>
    <div class="modal-body p-0">
        <div class="embed-video">
            <iframe class="howit-iframe" src="https://247invites-prod-asset.s3.me-south-1.amazonaws.com/assets/Video/Mobile_Guide.mp4" title="How It Works" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </div>
    <!-- <div class="modal-footer py-1 d-flex justify-content-between">
        <div class="row">
            <div class="col-md col-12">
                <div class="general_sans text-center text-md-left" style="font-weight: bold;">
                    Do you liked it? Go and create your own personlise card and video.
                </div>
            </div>
        </div>
        <div class="col-md-auto col-12 mt-3 mt-md-0 pb-3 pb-md-0">
            <a ngbTooltip="Customize card by yourself w-100 w-md-auto and preview instantly"
                class="btn-247 btn-primary-preview btn-large btn-medium-radius cursor-pointer w-100 d-block">Start
                Editing
            </a>
        </div>
    </div> -->
</div>